<template>
  <div :class="['h-[200vh] overflow-hidden', 'sticky top-0 -z-1']">
    <!-- 主内容容器 -->
    <Motion
      :initial="{ opacity: 0, scale: 0 }"
      :while-in-view="{ opacity: 1, scale: 1 }"
      :transition="{
        type: 'spring',
        stiffness: 20,
        damping: 10,
      }"
      :in-view-options="{
        once: true,
      }"
      :class="[
        'page_view',
        'sticky top-0',
        'flex justify-center items-center flex-col lg:gap-12 gap-8',
        'h-screen',
        'text-primary text-shadow-lg text-shadow-secondary/40',
      ]"
    >
      <NuxtImg
        :src="configSite.LOGO"
        alt="honor"
        draggable="false"
        :class="['lg:w-64 w-42', 'drop-shadow-2xl drop-shadow-white/40']"
      />

      <!-- 动画正文 -->
      <VueBitsSplitText
        :text="t('page.index.reveal.title', { expYear: new Date().getFullYear() - 1995 })"
        class-name="lg:text-5xl text-3xl font-semibold text-center lg:leading-16"
        :delay="60"
        :duration="1"
        ease="expo.out"
        split-type="chars"
        :from="{ opacity: 0, y: 40 }"
        :to="{ opacity: 1, y: 0 }"
        :threshold="0.1"
        root-margin="-100px"
      />
    </Motion>

    <!-- 聚光灯组件 -->
    <div :class="['size-full object-cover', 'absolute top-0 left-0 -z-1']">
      <ClientOnly>
        <VueBitsLightRays
          rays-origin="top-center"
          rays-color="#ffffff"
          :rays-speed="1.5"
          :light-spread="0.8"
          :ray-length="1.2"
          :follow-mouse="true"
          :mouse-influence="0.1"
          :noise-amount="0.1"
          :distortion="0.05"
          class-name="custom-rays"
        />
      </ClientOnly>
    </div>

    <!-- 固定定位背景 -->
    <video
      autoplay
      loop
      muted
      src="/video/business/customs.mp4"
      poster="/img/bg/home-2.avif"
      :class="['absolute inset-0 -z-2', 'w-full h-screen object-cover', 'brightness-60']"
    />
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n()
  const { configSite } = useConfigStatic()
</script>
